module.exports = __webpack_public_path__ + "static/media/crystal.0cc29c01.jpg";